import React from 'react'
import { FestGulan } from '../../component/about/FestGulan/FestGulan'

export default function FestGulanPage() {
  return (
    <>
      <FestGulan />
    </>
  )
}
